export default "__VITE_ASSET__CHKZl2FG__"